var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClosedEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3976 9.40462C15.6962 9.23149 16.0786 9.33323 16.2517 9.63185L18.0408 12.7178C18.2139 13.0164 18.1122 13.3988 17.8136 13.572C17.515 13.7451 17.1325 13.6434 16.9594 13.3447L15.1703 10.2588C14.9972 9.96017 15.0989 9.57775 15.3976 9.40462Z",
    fill: "#B3B7CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9385 11.0486C12.2785 10.9887 12.6026 11.2157 12.6625 11.5556L13.2172 14.7041C13.2771 15.044 13.0501 15.3681 12.7101 15.428C12.3702 15.4879 12.046 15.2609 11.9861 14.921L11.4315 11.7725C11.3716 11.4326 11.5986 11.1084 11.9385 11.0486Z",
    fill: "#B3B7CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0536 11.0407C8.39356 11.1004 8.62073 11.4245 8.56098 11.7644L8.00629 14.9207C7.94655 15.2607 7.62252 15.4878 7.28255 15.4281C6.94258 15.3683 6.71542 15.0443 6.77516 14.7043L7.32985 11.5481C7.3896 11.2081 7.71363 10.9809 8.0536 11.0407Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59364 9.40394C4.89264 9.57641 4.99521 9.95861 4.82274 10.2576L3.03368 13.3592C2.86121 13.6582 2.47901 13.7607 2.18 13.5883C1.881 13.4158 1.77843 13.0336 1.9509 12.7346L3.73997 9.63304C3.91244 9.33404 4.29464 9.23147 4.59364 9.40394Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.10731 7.70909C2.37584 7.4922 2.76935 7.53406 2.98623 7.80259C4.22969 9.34211 6.4745 11.25 10 11.25C13.5255 11.25 15.7704 9.34211 17.0138 7.80259C17.2307 7.53406 17.6242 7.4922 17.8927 7.70909C18.1613 7.92598 18.2031 8.31949 17.9862 8.58801C16.6047 10.2985 14.037 12.5 10 12.5C5.96304 12.5 3.39535 10.2985 2.01381 8.58801C1.79692 8.31949 1.83878 7.92598 2.10731 7.70909Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedEye);
export default __webpack_public_path__ + "static/media/closed-eye.8c8c0418595796cd347728521185506a.svg";
export { ForwardRef as ReactComponent };